import ReportsSerializer from './base';

export default class RubricElement extends ReportsSerializer {}
